<template>
    <div class="tree-box">
        <div v-for="(item,index) in treeData" @click.stop="changeTree(item)" :class="[{margin:item.parentId==-1&&index==0},{active:currentId==item.id}]" :key="index">
            <div :class="{'parent-title':item.parentId==-1}" :style="`cursor:${(!item.children||item.children.length==0)?'pointer':''};`" class="label-title">{{ serialNumber+(index+1)+(serial?'':'.')+item.name }}</div>
            <tree-component style="margin-left: 2rem;" v-if="item.children" :currentId="currentId" :treeData="item.children" :serial="serialNumber+(index+1)"></tree-component>
        </div>
    </div>
</template>

<script>
import Utils from '@/assets/js/Utils';
    export default {
        name:'TreeComponent',
        props:{
            treeData:{
                require:true,
                default:()=>[]
            },
            serial:{
                require:true,
                default:''
            },
            currentId:{
                require:true,
                default:''
            }
        },
        data(){
            return {
                serialNumber:this.serial?(this.serial+'.'):'',
            }
        },
        methods:{
            changeTree(item){
                if(!item.children||item.children.length==0){
                    Utils.$emit('change_tree',item.id);
                }
            }
        }
    }
</script>

<style lang="less" scoped>
.tree-box{
    height: 100%;
    &> :nth-child(n){
        margin-top: 1rem;
        color: #334681;
    }
}
.parent-title{
    font-size: 16px;
    font-weight: 700;
}
.label-title{
    font-size: 16px;
}
.margin{
    margin-top: 0 !important;
}
.active{
    color: var(--blue) !important;
}
</style>